<template>
  <div>
    <modal-base :title="$t('B0')" ref="info-modal-B0">
      <p>{{ $t("B1") }}</p>
      <p>{{ $t("B2") }}</p>
      <p>{{ $t("B3") }}</p>
      <p>{{ $t("B4") }}</p>
      <ul>
        <a
          v-for="link in hyperlinksB"
          v-bind:key="link"
          :href="link"
          target="_blank"
        >
          <li>{{ link }}</li>
        </a>
      </ul>
    </modal-base>
    <modal-base :title="$t('K0')" ref="info-modal-K0">
      <p>{{ $t("K1") }}</p>
      <p>{{ $t("K2") }}</p>
      <p>{{ $t("K3") }}</p>
      <p>{{ $t("K4") }}</p>
      <ul>
        <a
          v-for="link in hyperlinksK"
          v-bind:key="link"
          :href="link"
          target="_blank"
        >
          <li>{{ link }}</li>
        </a>
      </ul>
    </modal-base>
    <modal-base :title="$t('G0')" ref="info-modal-G0">
      <p>{{ $t("G1") }}</p>
      <p>{{ $t("G2") }}</p>
      <p>{{ $t("G3") }}</p>
      <p>{{ $t("G4") }}</p>
      <ul>
        <a
          v-for="link in hyperlinksG"
          v-bind:key="link"
          :href="link"
          target="_blank"
        >
          <li>{{ link }}</li>
        </a>
      </ul>
    </modal-base>
    <modal-base :title="$t('H0')" ref="info-modal-H0">
      <p>{{ $t("H1") }}</p>
      <p>{{ $t("H2") }}</p>
      {{ $t("H3") }}<br />
      {{ $t("H4") }}<br />
      {{ $t("H5") }}<br />
      {{ $t("H6") }}<br />
      {{ $t("H7") }}<br />
      {{ $t("H8") }}<br />
      {{ $t("H9") }}<br />
      {{ $t("H10") }}<br />
      {{ $t("H11") }}<br />
    </modal-base>
    <modal-base :title="$t('R0')" ref="info-modal-R0">
      <p>{{ $t("R1") }}</p>
      <p>{{ $t("R2") }}</p>
      <p>{{ $t("R3") }}</p>
    </modal-base>
    <modal-base :title="$t('S0')" ref="info-modal-S0">
      <p>{{ $t("S1") }}</p>
      <p>{{ $t("S2") }}</p>
    </modal-base>
  </div>
</template>

<script>
import ModalBase from "./ModalBase";
import { modalBaseMixin } from "../../mixins/modalBase";

export default {
  name: "ServiceDescriptionModals",
  components: { ModalBase },
  mixins: [modalBaseMixin],
  methods: {
    showModal(id) {
      this.$refs[id].show();
    }
  },
  data() {
    return {
      hyperlinksB: [
        "https://lra-fo.de/site/2_aufgabenbereiche/Sicherheit_Gesundheit_Verbraucherschutz/Gesundheitsamt/schwangerenberatung.php",
        "https://www.profamilia.de/bundeslaender/bayern/beratungsstelle-forchheim.html",
        "https://bamberg.donum-vitae-bayern.de/beratung-hilfe/allgemeine-schwangerenberatung",
        "http://www.caritas-stadt-bamberg.de"
      ],
      hyperlinksK: [
        "https://www.krankenkasseninfo.de/test/geburtsvorbereitungskurs-partner",
        "https://www.klinikumforchheim.de/abteilungen-experten/kliniken/klinik-fuer-frauenheilkunde-und-geburtshilfe/elternschule/"
      ],
      hyperlinksG: [
        "https://www.klinikumforchheim.de/abteilungen-experten/kliniken/klinik-fuer-frauenheilkunde-und-geburtshilfe/rund-um-die-geburt/",
        "https://www.geburtshauserlangen.de/"
      ]
    };
  }
};
</script>

<style scoped></style>
